import type { ResidentItem } from '@lmc/ts-common'
import { type SexCode, SexDescriptionEnum } from '@lmc/validations'
import { formatAddress } from 'common/utils'
import dayjs from 'dayjs'
import type { TFunction } from 'i18next'
import { incidentReportsConstants } from 'locale/incidentReports'
import { DATE_FORMAT } from './stepLayout'

/** The parts of a service user's record their details are read from. */
export type ServiceUserRecord = Pick<
  ResidentItem,
  'addresses' | 'dateOfBirth' | 'name' | 'nhsNumber' | 'preferredName'
>

/**
 * Who the case is about, as the details card and the PDF print them: the
 * name with any preferred name, then each detail formatted, or undefined
 * when it isn't recorded.
 */
export const serviceUserDetails = (
  t: TFunction,
  resident: ServiceUserRecord
) => {
  const legalName = [resident.name?.first, resident.name?.last]
    .filter(Boolean)
    .join(' ')
    .trim()
  // `ResidentItem` lacks the demographics the read returns.
  const { demographics } = resident as {
    demographics?: { sex?: SexCode | null }
  }
  const sexCode = demographics?.sex ?? undefined

  return {
    address: formatAddress(resident.addresses?.[0]),
    dateOfBirth: resident.dateOfBirth
      ? t(incidentReportsConstants.CASE_V2_SU_DATE_OF_BIRTH_AGE, {
          age: dayjs().diff(resident.dateOfBirth, 'year'),
          date: dayjs(resident.dateOfBirth).format(DATE_FORMAT)
        })
      : undefined,
    name: resident.preferredName
      ? t(incidentReportsConstants.CASE_V2_SU_PREFERRED_NAME, {
          name: legalName,
          preferredName: resident.preferredName
        })
      : legalName,
    nhsNumber: resident.nhsNumber,
    sex: sexCode ? SexDescriptionEnum[sexCode] : undefined
  }
}
